import Header from '@ui/elements/Header'
import Page from '@shell/Page'
import { View } from 'react-native'
import PackagePointsTile from '@order/PackagePoints/PackagePointsTile'
import { PackagePointsTileProps } from '@order/PackagePoints/types'
import { sDefaultTemplate } from '@order/steps/templates/Default/styles'

const options: PackagePointsTileProps[] = [
  {
    tier: 'standard',
    points: ['Standard Index', 'Scratch protection'],
    image: require('@/images/examples/index-sv-premium.png'),
    price: {
      base: 20,
    },
    discount: {
      scope: 'text',
      text: '-10€',
      label: '+EXTRA PAIR',
    },
  },
  {
    tier: 'comfort',
    points: ['Standard Index', 'Scratch protection', 'Anti-reflective coating'],
    image: require('@/images/examples/index-vf-standard-comfort.jpg'),
    price: {
      base: 35,
    },
    discount: {
      type: 'percentage',
      amount: -50,
      scope: 'variable',
      variable: 'package',
    },
  },
  {
    tier: 'highend',
    points: [
      'Mid Index: up to 30% thinner',
      'Scratch protection',
      'Anti-reflective coating',
    ],
    image: require('@/images/examples/index-vf-highend.jpg'),
    imageText: '+50% Far / Near',
    price: {
      base: 130,
    },
    discount: {
      scope: 'text',
      text: '-50%',
      label: '+EXTRA PAIR',
    },
  },
  {
    tier: 'worldclass',
    points: [
      'Super High Index: up to 60% thinner',
      '8x stronger scratch protection',
      'Super Anti-reflective coating',
      'Lotus Effect',
    ],
    image: require('@/images/examples/index-vf-steiner.jpg'),
    imageText: '+70% Far / Near',
    price: {
      base: 250,
    },
    discount: {
      scope: 'text',
      text: '-50%',
      label: '+EXTRA PAIR',
    },
    isRecommended: true,
  },
]
export default function DevPackagesPointsPage() {
  return (
    <Page stage="configuration">
      <Header
        title="Packages"
        desc="Choose the offer that best suits your needs. The highlighted package is the recommended one based on your prescription."
      />
      <View className={sDefaultTemplate}>
        {options.map((option, index) => (
          <PackagePointsTile key={`${option.tier}-${index}`} {...option} />
        ))}
      </View>
    </Page>
  )
}
